var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoicesummarywhite3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3988 24.0004H10.3997C8.9657 24.0004 7.80017 23.3556 7.80017 21.3339V2.66652C7.80017 1.19781 8.9657 0 10.3997 0H20.0382L26 6.11457V21.3339C26 23.3556 24.8345 24.0004 23.3988 24.0004ZM23.3988 7.99956H18.1998V2.66652H10.3997V21.3339H23.4014L23.3988 7.99956ZM20.0191 11.2113H11.6994V9.14633H20.0191V11.2113ZM22.099 15.3396H11.6994V13.7576H22.099V15.3396ZM22.099 19.468H11.6994V17.4047H22.099V19.468ZM22.099 28.6004H6.50042C5.70378 28.6004 3.89921 26.8028 3.89921 25.3333V3.99935H6.50042V25.3333H22.099V28.6004ZM18.1998 32H2.59947C1.16551 32 0 30.8031 0 29.3335V7.99956H2.59947V29.3335H18.1998V32Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicesummarywhite3);
export default __webpack_public_path__ + "static/media/invoicesummarywhite3.9b2bdc09cde856c34ee98e630a1dbd4d.svg";
export { ForwardRef as ReactComponent };